import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { FontStyles } from "../utils/font-styles.ts";

export interface PreviewBannerProps {
  message?: string;
  lastUpdatedDate?: string;
}

const componentContainer = "flex p-4 md:p-6 justify-between items-center self-stretch bg-loch w-full";
const innerContainer =
  "flex flex-col gap-1.5 md:flex-row md:max-w-espc-max-content md:w-full md:mx-auto justify-between";
const previewText = `flex items-center gap-2.5 text-neutral-white font-medium leading-none md:leading-none ${FontStyles["body-l"]}`;
const dateText = `flex items-center gap-2.5 opacity-75 text-neutral-white leading-none md:leading-none ${FontStyles["body-md"]}`;

export const PreviewBanner = ({ message, lastUpdatedDate }: PreviewBannerProps) => {
  return (
    <div className={componentContainer}>
      <div className={innerContainer}>
        <p className={previewText}>{message}</p>
        {lastUpdatedDate && <p className={dateText}>Last updated on {lastUpdatedDate}</p>}
      </div>
    </div>
  );
};
